__turbopack_context__.v({
  "expanded": "PlaylistPlaybar-module-scss-module__7p1imG__expanded",
  "playlistPlaybar": "PlaylistPlaybar-module-scss-module__7p1imG__playlistPlaybar",
  "playlistPlaybarArrowContainer": "PlaylistPlaybar-module-scss-module__7p1imG__playlistPlaybarArrowContainer",
  "playlistPlaybarSelectedClip": "PlaylistPlaybar-module-scss-module__7p1imG__playlistPlaybarSelectedClip",
  "playlistPlaybarVideosCount": "PlaylistPlaybar-module-scss-module__7p1imG__playlistPlaybarVideosCount",
  "playlistPlaybarVideosTotal": "PlaylistPlaybar-module-scss-module__7p1imG__playlistPlaybarVideosTotal",
  "redDot": "PlaylistPlaybar-module-scss-module__7p1imG__redDot",
  "tiny": "PlaylistPlaybar-module-scss-module__7p1imG__tiny",
});
